export default __webpack_public_path__ + "static/media/ChallengeRankSecond.904ac0d3.svg";